import { call, put } from 'redux-saga/effects'
import { addMessageAction, clearMessageAction } from 'actions/messageActions'
import { delay, takeEvery } from 'redux-saga'
import { notifyHoneybadgerAction } from 'actions/applicationActions'
import { MESSAGE } from 'actions/messageActionTypes'

export function* message(action) {
  try {
    const { key, message } = action
    yield put(addMessageAction(key, message))
    // hold general error messages around a bit longer
    if (key === 'generalError') yield call(delay, 2400)
    else yield call(delay, 1200)

    if (key === 'saveState') yield put(addMessageAction('saveState', 'Saved'))
    else yield put(clearMessageAction(key, message))
  } catch (err) {
    yield put(notifyHoneybadgerAction(err, action))
  }
}

export function* watchMessage() {
  yield takeEvery(MESSAGE, message)
}



// WEBPACK FOOTER //
// ./src/sagas/messageSaga.js